import { MlmState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
    packagesList: (state: MlmState) => state.packagesList,
    qualification: (state: MlmState) => state.qualification,
    activePackage: (state: MlmState) => state.activePackage,
    invoiceResponse: (state: MlmState) => state.invoiceResponse,
    binaryTree: (state: MlmState) => state.binaryTree,
    recentRegistrations: (state: MlmState) => state.recentRegistrations,
    transactionsResponse: (state: MlmState) => state.transactionsResponse,
    toggledTreeIds: (state: MlmState) => state.toggledTreeIds,
    treeUsersChildren: (state: MlmState) => state.treeUsersChildren,
    companyStats: (state: MlmState) => state.companyStats,
    userRefInfo: (state: MlmState) => state.userRefInfo,
    userSigmaRings: (state: MlmState) => state.userSigmaRings,
    sigmaRings: (state: MlmState) => state.sigmaRings,
    // 13.04.2026
    xcoinPackageList: (state: MlmState) => state.xcoinPackagesList,
    xcoinActivePackages: (state: MlmState) => state.xcoinActivePackages,
    // 20.04.2026
    userXcoinPackageList: (state: MlmState) => state.userXcoinPackagesList,
    // 27.04.2026
    physicalNodesList: (state: MlmState) => state.physicalNodesList,
    physicalNodesActive: (state: MlmState) => state.physicalNodesActive,
    virtualNodesList: (state: MlmState) => state.virtualNodesList,
    virtualNodesActive: (state: MlmState) => state.virtualNodesActive,
    // 31.05.2026
    userMonthlyTurnover: (state: MlmState) => state.userMonthlyTurnover,
};

const {read} = getStoreAccessors<MlmState, State>('');

export const readPackagesList = read(getters.packagesList);
export const readQualification = read(getters.qualification);
export const readActivePackage = read(getters.activePackage);
export const readInvoiceResponse = read(getters.invoiceResponse);
export const readBinaryTree = read(getters.binaryTree);
export const readRecentRegistrations = read(getters.recentRegistrations);
export const readTransactionsResponse = read(getters.transactionsResponse);
export const readToggledTreeIds = read(getters.toggledTreeIds);
export const readTreeUsersChildren = read(getters.treeUsersChildren);
export const readCompanyStats = read(getters.companyStats);
export const readUserRefInfo = read(getters.userRefInfo);
export const readUserSigmaRings = read(getters.userSigmaRings);
export const readSigmaRings = read(getters.sigmaRings);
//13.04.2026
export const readXcoinPackages = read(getters.xcoinPackageList);
export const readXcoinActivePackages = read(getters.xcoinActivePackages);
//20.04.2026
export const readUserXcoinPackages = read(getters.userXcoinPackageList);
//27.04.2026
export const readPhysicalNodesList = read(getters.physicalNodesList);
export const readPhysicalNodesActive = read(getters.physicalNodesActive);
export const readVirtualNodesList = read(getters.virtualNodesList);
export const readVirtualNodesActive = read(getters.virtualNodesActive);
// 31.05.2026
export const readUserMonthlyTurnover = read(getters.userMonthlyTurnover);